import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f0f21c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "När behöver jag boka plats?", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hur genomför jag en platsreservation?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.eurail.com/en/plan-your-trip/about-reservations/trains-with-additional-supplements" }, " Eurails hemsida ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Interrailkort för barn", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "country-list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Interrailkort gäller inte i ditt hemland", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "10 resdagar inom två månader", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "15 resdagar i följd", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import TextBlock from "../blocks/TextBlock.vue";
import ContentWrapper from "../generics/ContentWrapper.vue";
import PageTitle from "../blocks/PageTitle.vue";
import CustomPic from "../generics/CustomPic.vue";
import CustomTable from "../generics/CustomTable.vue";
import meta from "@/data/meta.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'InterrailCards',
  setup(__props) {

var ticket_ref_object = [
	{
		Interailkort: "4 dagar på 1 månad",
		Ungdom: "2349:- (2949:-)",
		Vuxen: "3099:- (3949:-)",
		Senior: "2799:- (3549:-)",
	},
	{
		Interailkort: "4 dagar på 1 månad",
		Ungdom: "2349:- (2949:-)",
		Vuxen: "3099:- (3949:-)",
		Senior: "2799:- (3549:-)",
	},
	{
		Interailkort: "4 dagar på 1 månad",
		Ungdom: "2349:- (2949:-)",
		Vuxen: "3099:- (3949:-)",
		Senior: "2799:- (3549:-)",
	},
	{
		Interailkort: "4 dagar på 1 månad",
		Ungdom: "2349:- (2949:-)",
		Vuxen: "3099:- (3949:-)",
		Senior: "2799:- (3549:-)",
	},
];

var countrylist = [
	"Belgien",
	"Bosnien-Hercegovina",
	"Bulgarien",
	"Danmark",
	"Estland",
	"Finland",
	"Frankrike",
	"Grekland",
	"Irland",
	"Italien",
	"Kroatien",
	"Lettland",
	"Litauen",
	"Luxemburg",
	"Makedonien",
	"Montenegro",
	"Nederländerna",
	"Norge",
	"Polen",
	"Portugal",
	"Rumänien",
	"Schweiz",
	"Serbien",
	"Slovakien",
	"Slovenien",
	"Spanien",
	"Storbritannien",
	"Tjeckien",
	"Turkiet",
	"Tyskland",
	"Ungern",
	"Österrike",
	"Italien",
	"Grekland",
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).interrailCards), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Interrailkort",
      backgroundImageClass: "background-london"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "Om du har bestämt dig för att du vill ta dig fram i Europa med hjälp av tåg är det bästa alternativet att inhandla interrailkort. Interrail erbjuder många varianter, men i korta drag innebär det att du köper ett kort som är laddat med ett visst antal resdagar. Under dessa resedagar kan du hoppa på vilket tåg som helst, men om du vill vara säker på att få sitt-, eller sovplats måste du boka detta i förväg. Göra en, så kallad, platsreservation. Då tillkommer en liten extra avgift, men denna är liten i förhållande till tågresans fulla pris."
        }),
        _createVNode(CustomPic, {
          picturePath: 'pictures/backpack.jpg',
          height: "12rem"
        }, null, 8, ["picturePath"]),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" Det finns vissa tåg som ofta är fullbokade, har få platser avsatta för interrail, eller rent av kräver platsbokning. Det gäller ofta för snabbtåg, nattåg eller tåg som färdas mellan flera länder. Det är därför viktigt att planera sin rutt innan man ger sig av och ge sig möjlighet att upptäcka biljetter som behöver bokas på förhand. Det bör också nämnas att privatägda tågbolag, som till exempel Thalys och Thello, inte är en del av interrail-samarbetet. Man kan därmed inte åka på dessa tåg med endast ett interrailkort, men det kan ge rabatt på biljettpriset däremot. De tåg som man å andra sidan bara kan hoppa på är just de statligt ägda tågbolagen och regionaltrafiken i varje land. Det vill säga SJ:s motsvarigheter i Europa. "),
            _hoisted_2,
            _hoisted_3,
            _createTextVNode(" För de som vill åka tåg inom endast ett land finns specialanpassade interrailkort för detta. De kallas Interrail One Country Pass. ")
          ]),
          _: 1
        }),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Platsbokning på ett tåg under din resa erhåller du enklast och billigast genom railplanner-appen. När du planerar in resan i appen så dyker där upp information om att platsreservation kan behövas. Därtill erhålls länkar till rekommenderade sajter för platsbokning givet den planerade resan. Genomför din platsbokning där. "),
            _hoisted_5,
            _hoisted_6,
            _createTextVNode("I vissa fall går platsreservation inte att genomföra genom de sajter railplanner-appen rekommenderar. Vi vill göra dig varse om att det fortfarande kan finnas möjlighet att boka plats på tågoperatörens hemsida eller på tågstationen. Platsreservation genom tågoperatören kommer att resultera i den lägsta möjliga priset. ")
          ]),
          _: 1
        }),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _createTextVNode(" För vissa tåg räcker inte att endast genomföra en platsreservation, utan krävs också ett ytterligare tillägg, \"additional supplements\". Det är en tilläggsavgift som du måste betala för att åka med det specifika tåget. I Railplanner-appen ser du om något av dina planerade tåg omfattas av en tilläggsavgift. Om så är fallet, kolla på "),
            _hoisted_7,
            _createTextVNode(" hur du bäst betalar avgiften samt hur stor den är. ")
          ]),
          _: 1
        }),
        _createVNode(TextBlock, {
          header: "Prislista för Global Pass",
          content: "Priset för global passes beror på typ av interrailkort, passangerarens ålder samt vald komfort. Nedan visas vår prislista för Global Pass:"
        }),
        _createVNode(CustomTable, { "table-items": _unref(ticket_ref_object) }, null, 8, ["table-items"]),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _createTextVNode("Priser inom parentes är priser för en 1:a klass biljett.")
          ]),
          _: 1
        }),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" Barn under 12 år åker gratis om de åker tillsammans med föräldrar. Varje vuxen har lov att färdas med två barn gratis. Skulle ett barn resa utan föräldrar, eller en förälders kvot om två barn redan fyllts så kommer barnet bli tvungen att skaffa ett ungdomskort. "),
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" Tillhör du antingen åldersgruppen senior eller ungdom och planerar att resa med barn, så behöver du uppgradera din biljett till vuxen. Det är betydligt mer prisvärt än att uppgradera barnets biljett till ungdom. "),
            _hoisted_11,
            _hoisted_12,
            _createTextVNode(" Barn upp till 4 års ålder behöver inte ha ett personligt interrailkort. ")
          ]),
          _: 1
        }),
        _createVNode(TextBlock, { header: "Ditt interrailkort gäller i 33 Europeiska länder:" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countrylist), (country, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${country}-${index}-country`
                }, _toDisplayString(country), 1))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(CustomPic, { picturePath: 'pictures/interrail-countries-tagluffaieuropa.png' }, null, 8, ["picturePath"]),
        _createVNode(TextBlock, null, {
          default: _withCtx(() => [
            _hoisted_14,
            _createTextVNode(" Interrail Global Pass ger dig generellt 2 resor i ditt hemland. Sverige är ett långt land och därför ges svenska tågresenärer möjlighet till 4 resor i sitt hemland: 2 för att åka iväg och 2 för att återvända, med flera tågbyten inkluderade. Ditt hemland är det land där du är bosatt och exempelvis har permanent boende, arbetar, studerar och betalar skatt. Du kan resa under en resdag för att lämna ditt hemland (utresan) och en resdag för att återvända (inresan). Du kan använda dessa resor i ditt eget land när som helst under din Pass giltighetstid. "),
            _hoisted_15,
            _hoisted_16,
            _createTextVNode(" Värt att observera är att utresa och inresa inte räknas som extra resdagar, men att de måste genomföras under ditt pass giltighetstid. Har du ett pass med "),
            _hoisted_17,
            _createTextVNode(", så behöver in- och utresa ske inom de två månaderna. Har du, å andra sidan, ett pass med "),
            _hoisted_18,
            _createTextVNode(", så behöver in- och utresa ske inom de 15 dagarna. "),
            _hoisted_19,
            _hoisted_20,
            _createTextVNode(" När du reser med ett mobilpass känner appen automatiskt igen en utgående eller ingående resa, baserat på ditt hemland. Om du lägger till en utgående eller ingående resa till ditt pass, kommer ett popup-fönster att meddela dig att du kommer att använda en av de två tillgängliga ut/inresor. Du måste godkänna detta innan du kan lägga till din resa i ditt pass. "),
            _hoisted_21,
            _hoisted_22,
            _createTextVNode(" Tänk på att när du vill resa från ett land till ett annat och måste resa genom ditt hemland, kommer appen att förbruka både den in- och utgående resan på denna resa.")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})